const dashboard = {
    boxTitle: 'text-black font-bricolage text-[18px] md:text-[20px] font-bold leading-none',
    subtitle: 'text-[#8D929C] font-bricolage text-[12px] text-xs',
    itemTitle: 'text-black font-bricolage text-[14px] leading-none',
};

export default dashboard;
